import { memo, useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Payment, PaymentType, isPayPal, isCredit } from 'consts/BulkPaymentConst';
import { RoutePath } from 'consts/RoutePath';
import { GetSiteResData } from 'requests/RequestSite';
import { GetSiteSettlementResData, GetBulkOrderResData } from 'requests/RequestPayment';
import { bulkRedirect } from 'utils/bulkPaymentUtils';
import { ErrorTemplate } from './ErrorTemplate';
import { CircularProgress } from '@material-ui/core';

// 注文完了画面
type CompleteComponentProps = {
	payMethod: PaymentType;
	site: GetSiteResData;
	siteSettlement: GetSiteSettlementResData;
	is_via_portal: boolean;
	state?: string;
	redirect_uri: string;
	order: GetBulkOrderResData;
};
export const BulkPaymentCompleteTemplate = memo(() => {
	const history = useHistory<CompleteComponentProps>();
	const { payMethod, site, siteSettlement, is_via_portal, state, redirect_uri, order } = history.location.state;

	const scrollRef = useRef(null);
	const scrollTop = () => {
		scrollRef.current.scrollIntoView();
	};
	const [timer, setTimer] = useState(undefined);
	const clearTimer = () => {
		clearTimeout(timer);
	};
	useEffect(() => {
		const timer = setTimeout(function () {
			redirectService();
		}, 5000);
		setTimer(timer);
	}, []);

	const [isServiceError, setIsServiceError] = useState(false);
	const [returnTransitioning, setReturnTransitioning] = useState(false);
	const redirectService = () => {
		setReturnTransitioning(true);
		if (isPayPal(payMethod)) {
			bulkRedirect({ payMethod: Payment.PAYPAL, is_via_portal, state, redirect_uri, order });
			return;
		}
		if (isCredit(payMethod)) {
			bulkRedirect({ payMethod: Payment.CREDIT, is_via_portal, state, redirect_uri, order });
			return;
		}

		if (!siteSettlement?.error_button_display || !siteSettlement?.error_return_url) {
			history.push(RoutePath.ERROR);
			return;
		}
		setIsServiceError(true);
		setReturnTransitioning(false);
	};

	const transButtonLabel = () => {
		if (site?.bulk_payment_button_display_complete) {
			return site.bulk_payment_button_display_complete;
		}
		if (site?.site_name) {
			return `${site.site_name}へ`;
		}
		return '次へ';
	};

	useEffect(() => {
		scrollTop();
		document.title = 'お支払い方法の選択｜完了';
	}, []);

	return (
		<main>
			{isServiceError ? (
				<ErrorTemplate
					button_display={siteSettlement.error_button_display}
					return_url={siteSettlement.error_return_url}
				/>
			) : (
				<div className="section mypage" ref={scrollRef}>
					<div className="section-in" style={{ marginTop: 50 }}>
						<div className="thankyou-box">
							<img src="../images/img-thankyou.svg" alt="Thank You." />
						</div>
						<p>
							お支払いの手続きが完了いたしました。
							<br />
							※5秒後に自動的に次ページへ移動します。
						</p>
						<div className="btn-box">
							<div className="btn gr">
								{returnTransitioning ? (
									<CircularProgress />
								) : (
									<button
										onClick={() => {
											clearTimer();
											redirectService();
										}}
									>
										{transButtonLabel()}
									</button>
								)}
							</div>
						</div>
					</div>
				</div>
			)}
		</main>
	);
});
